module.exports = __webpack_public_path__ + "static/media/whatsapp.d89665b2.svg";